<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <div class="order-container">
      <el-badge :value="static.newOrderCount" type="primary">
        <el-button size="small"  @click="onBadgeClick(0)">待报价</el-button>
      </el-badge>
      <el-badge :value="static.noPayOrderCount" type="success">
        <el-button size="small" @click="onBadgeClick(1)">待付款</el-button>
      </el-badge>
      <el-badge :value="static.preAuditOrderCount" type="warning">
        <el-button size="small" @click="onBadgeClick(2)">付款待审核</el-button>
      </el-badge>
      <el-badge :value="static.unAuditOrderCount" type="warning">
        <el-button size="small" @click="onBadgeClick(7)">付款审核未通过</el-button>
      </el-badge>
      <el-badge :value="static.preDeliveryOrderCount" type="danger">
        <el-button size="small" @click="onBadgeClick(3)">待发货</el-button>
      </el-badge>
      <el-badge :value="static.preSignOrderCount" type="info">
        <el-button size="small" @click="onBadgeClick(4)">待签收</el-button>
      </el-badge>
    </div>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import {fetchHomeStaticF1} from '@/api/order'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  data() {
    return {
      timer:"",
      static:{}
    }
  },
  created() {
    this.timer = setInterval(this.getOrderStatic,10000);
    // this.$store.dispatch('connect');
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getOrderStatic(){
      let self = this;
      fetchHomeStaticF1().then(response => {
        self.static = response.data;
      });
    },
    onBadgeClick(value){
      this.$router.push({path: '/oms/order', query: {staticType: value}});
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .order-container {
    margin-top: 6px;
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 100px;
  }
  .avatar-container {
    margin-top: 5px;
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue